import { render, staticRenderFns } from "./ShortTermLoans.vue?vue&type=template&id=27621a20&"
import script from "./ShortTermLoans.vue?vue&type=script&lang=js&"
export * from "./ShortTermLoans.vue?vue&type=script&lang=js&"
import style0 from "./ShortTermLoans.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports